<template>
  <div class="reply-box">
    <div class="container clearfix">
      <div class="user-icon">
        <img :src="fimgSrc">
      </div>
      <div class="reply-container">
        <div class="user-info clearfix">
          <div class="user-name">{{fuserName}}</div>
          <div class="topic-time">{{ftopicTime}}</div>
        </div>
        <div class="reply-txt-box">
          <div class="reply-txt clearfix">
            <div class="reply-context" v-html="freplyContext">
            </div>
            <div class="reply-but clearfix">
              <img src="../../assets/icon-like.svg" @click="likeClick">{{flikeCount}}
              <span @click="replyCancelClick" :class="freplyClass">{{freplyTxt}}</span>
            </div>
          </div>
          <div>
            <markdownReply v-if="fdisplayReply" @eventReleaseReply="releaseReply"></markdownReply>
          </div>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import markdownReply from "@/components/common/markdownReply";
import serviceApi from "@/utils/serviceApi";
import {marked} from 'marked'
export default {
  name: "ReplyBox",
  data(){
    return{
      likeCount:0
    }
  },
  props:{
    replyInfo: {
      type: Object,
      default: ()=>{
        return{
            replyId: "",
            author: {
              authorId:"",
              authorName:"authorName",
              authorIcon:"undefined"
            },
            replyContext: "code",
            replyTime: "2023-12-12 01:23:32",
            likeCount: 10,
        }
      }
    },
    curReplyId: String
  },

  computed:{
    fimgSrc:function (){
      if (this.replyInfo.author.authorIcon == undefined ||
          this.replyInfo.author.authorIcon == 'undefined' ||
          this.replyInfo.author.authorIcon == ''){
        return './static/image/head.png';
      }else {
        return this.replyInfo.author.authorIcon;
      }
    },

    fuserName:function (){
      return this.replyInfo.author.authorName;
    },

    ftopicTime: function (){
      return this.replyInfo.replyTime;
    },

    flikeCount: function (){
      if (this.replyInfo.likeCount + this.likeCount == 0){
        return ''
      }else{
        return this.replyInfo.likeCount + this.likeCount
      }
    },

    freplyContext:function (){
      return marked(decodeURI(this.replyInfo.replyContext))
    },

    freplyTxt: function (){
      if (this.curReplyId == this.replyInfo.replyId){
        return '消取回复'
      }else{
        return '回复'
      }
    },

    freplyClass: function(){
      if (this.curReplyId == this.replyInfo.replyId){
        return 'cancel-reply'
      }else{
        return 'display-reply'
      }
    },

    fdisplayReply: function (){
      if (this.curReplyId == this.replyInfo.replyId){
        return true;
      }else{
        return false;
      }
    },
  },
  methods:{
    likeClick: function (){
      serviceApi.UpdateReply(
          {replyId: this.replyInfo.replyId, state: 'like'},
          ()=>{
            this.likeCount = this.likeCount + 1;
          })
    },
    replyCancelClick: function (){
      if (this.curReplyId == this.replyInfo.replyId){
        this.$emit('event-reply-cancel', '')
      }else{
        this.$emit('event-reply-cancel', this.replyInfo.replyId)
      }
    },

    releaseReply: function (htmlStr, opter){
      this.$emit('event-release-reply', htmlStr, opter)
    }
  },
  components:{
    markdownReply
  }
}
</script>

<style scoped>
.reply-box{
  background-color: #fff;
  padding-top: 15px;
}

.container{
  padding-left: 10px;
  min-height: 80px;
}
.user-icon{
  float: left;
  padding-top: 8px;
  width: 50px;
}
.user-icon img{
  width: 40px;
  height: 40px;
}

.reply-container{
  margin-left: 50px;
}

.user-info{
  height: 50px;
  line-height: 50px;
}
.user-name{
  float: left;
  font-size: 16px;
}
.topic-time{
  float: right;
  padding-right: 10px;
  font-size: 12px;
  width: 120px;
}

.reply-txt{

}

.reply-txt-box{
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.reply-context{
  float: left;
  font-size: 18px;
}

.reply-but{
  float: right;
  padding-right: 10px;
  font-size: 5px;
  width: 120px;
}

.reply-but img{
  padding-top: 12px;
  float: left;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.reply-but span{
  float: right;
  display: block;
  border-radius: 5px;
  height: 26px;
  line-height: 26px;
  margin-left: 10px;
  margin-top: 8px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
}
.display-reply{
  border: 1px solid #2e7eee;
  background-color: #2e7eee;
  color: #fff;
}
.cancel-reply{
  border: 1px solid #eee;
  background-color: #eee;
  color: #666;
}

</style>
